import { ICbicContentMst } from "../../cbic-content-mst.model";
import { CbicMenuMstService } from "app/entities/cbic-menu-mst/service/cbic-menu-mst.service";

export class ContentNavigationService {
    private contentNavigation: Navigation[] = [];
    constructor(
        private menuService:CbicMenuMstService,
    ){}
    
    getMenuItem(): any{
        return this.menuService.getSelectedMenu();
    }

    getNavigation(): Navigation[] {
        return this.contentNavigation;
    }

    decodeBase64(object: any): string {
        return atob(object);
    }

    encodeBase64(object: any): string {
        return btoa(object);
    }

    updateNavigator(cbicContentMst: ICbicContentMst | undefined): void {
        if (!cbicContentMst){
            return;
        }
        let inx = 0;
        if (this.contentNavigation.length > 0) {
            if (this.contentNavigation[0].contentType !== cbicContentMst?.contentType?.id
                || this.isPathEqual(this.getMenuItem().path, cbicContentMst.path??"")) {
                this.contentNavigation.splice(0);
            } else {
                const nav_id = this.encodeBase64(cbicContentMst.id);
                while (inx < this.contentNavigation.length) {
                    if (this.contentNavigation[inx].id === nav_id) {
                        break;
                    }
                    inx++;
                }
                while (this.contentNavigation.length > inx) {
                    this.contentNavigation.pop();
                }
            }
        }

        this.contentNavigation.push({
            id: this.encodeBase64(cbicContentMst?.id),
            contentType: cbicContentMst?.contentType?.id,
            displayTextEn: cbicContentMst?.titleEn,
            displayTextHi: cbicContentMst?.titleHi
        });
    }

    isContentUrl(url: string){
        return url.includes("entities/cbic-content-mst");
    }

    getContentId(url: string): string{
        if(!this.isContentUrl(url)){
            return "0";
        }
        const urlParts = decodeURI(url).split("/");
        return this.decodeBase64(urlParts[urlParts.length-1]);
    }

    isPathEqual(path1:string, path2:string): boolean{
        if(this.isContentUrl(path1) && this.isContentUrl(path2)){
            const p1_id = this.getContentId(path1);
            const p2_id = this.getContentId(path2);
            return p1_id === p2_id;
        }
        return false;
    }

    showMenuLink(): boolean{
        const id = this.getContentId(this.getMenuItem().path);
        return this.decodeBase64(this.contentNavigation[0].id) !== id;
    }
}

export class Navigation {
    constructor(
        public id?: string,
        public contentType?: number | null | undefined,
        public displayTextEn?: string | null,
        public displayTextHi?: string | null,
    ) { }
}